import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { ReactComponent as RobotIcon } from "../../assets/robot.svg";
import { ReactComponent as BetaIcon } from "../../assets/beta.svg";
import { useBoundStore } from "../../stores/useBoundStore";

const Holder = styled.div`
  padding: 1rem;
  background-color: ${(props) => `${props.theme.colors.color1}0D`};
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  button {
    text-align: left;
    h2,
    p {
      margin: 0;
    }
  }

  .title {
    display: flex;
    gap: 0.2rem;
    align-items: center;
    svg:last-child {
      rect {
        stroke: ${(props) => props.theme.colors.color1};
      }
      path {
        fill: ${(props) => props.theme.colors.color1};
      }
    }

    svg:first-child {
      rect,
      line,
      path,
      circle {
        stroke: ${(props) => props.theme.colors.color1};
      }
    }
  }
`;

const Content = styled.div`
  width: 100%;
  margin: 2rem 0 0 0;
`;

function Accordion(props) {
  const [open, setOpen] = useState(false);
  const colorScheme = useBoundStore((state) => state.colorScheme);

  return (
    <Holder>
      <button onClick={() => setOpen(!open)}>
        <div className="title">
          <h2>
            0{props.step} {props.title}
          </h2>
          {props.ai && (
            <div color={colorScheme} className="title">
              <RobotIcon /> <BetaIcon />
            </div>
          )}
        </div>

        <p>{props.description}</p>
      </button>
      {open && <Content>{props.children}</Content>}
    </Holder>
  );
}

Accordion.propTypes = {
  step: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ai: PropTypes.bool,
};

export default Accordion;
